import setCssVar from '../utils/setCssVar';

export default class AlertBanner {
  constructor(elem, _) {
    this.elem = elem;
    this.closeBtn = this.elem.querySelector('.js-alert-banner-close');
    this.isManuallyHidden = window.sessionStorage.getItem('alertBanner') === 'false';
  }
  
  toggle(bool = true) {
    switch (bool) {
      case true:
        this.elem.setAttribute('aria-hidden', 'false');
        this.elem.removeAttribute('hidden');
        break;
      case false:
        this.elem.setAttribute('aria-hidden', 'true');
        this.elem.setAttribute('hidden', '');
        break;
      default:
    }
  }

  close() {
    this.toggle(false);
    window.sessionStorage.setItem('alertBanner', false);
  }

  init() {
    if (!this.elem) return;
    this.toggle(!this.isManuallyHidden);
    this.closeBtn.addEventListener('click', this.close.bind(this));
  }
};
